import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Skeleton, Text } from '@radix-ui/themes';
import clsx from 'clsx';

const SkeletonTable = () => {
  return (
    <Table className={clsx('')}>
      <TableHeader>
        <tr>
          {[0, 0, 0, 0, 0].map((_, i: number) => {
            return (
              <TableHead key={`skeleton-head-${i}`}>
                <Skeleton>Header</Skeleton>
              </TableHead>
            );
          })}
        </tr>
      </TableHeader>
      <TableBody>
        {[0, 0, 0, 0, 0, 0, 0, 0].map((_, i: number) => {
          return (
            <TableRow key={`skeleton-row-${i}`}>
              {[0, 0, 0, 0, 0].map((_, j: number) => {
                return (
                  <TableCell key={`skeleton-cell-${j}`}>
                    <Text>
                      <Skeleton>Header Header Header Header</Skeleton>
                    </Text>
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default SkeletonTable;
